import type { SVGProps } from 'react';
import * as React from 'react';

const ThreemfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/threemf">
      <g id="Vector" filter="url(#filter0_dd_3816_38019)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#DC2626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38019)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <g id="icon">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4264 20.5253L28.8751 17.9904V29.6199L20.6415 32.9973L20.4408 21.3597L20.4264 20.5253ZM11.3333 17.9904L19.7902 20.5276L19.8 21.0968L20.0051 33.0001L11.3333 29.6158V17.9904ZM20.1042 19.9572L11.7823 17.4609C14.7785 16.6534 19.4521 15.3945 20.1037 15.2223L28.4948 17.4405L20.1042 19.9572ZM26.3012 26.5587L27.0951 20.4845L27.9722 20.18L26.7952 28.2597L25.9326 28.6155L24.9296 23.3403L23.8876 29.4595L22.9778 29.8344L21.6971 22.36L22.6565 22.0269L23.5076 27.6557L24.5383 21.3729L25.3127 21.1039L26.3012 26.5587ZM16.7993 27.4708C16.7993 27.3145 16.7821 27.1686 16.7466 27.0341C16.7112 26.8995 16.6471 26.7637 16.5539 26.6282C16.4608 26.4928 16.3331 26.3496 16.1708 26.1992C16.0086 26.0493 15.8009 25.8788 15.5482 25.6889C15.2719 25.4844 15.0188 25.2717 14.787 25.0522C14.5561 24.8331 14.358 24.6027 14.1921 24.3614C14.0272 24.1206 13.8976 23.8647 13.8045 23.5938C13.7113 23.323 13.665 23.0335 13.665 22.7245C13.665 22.4191 13.7131 22.1537 13.8104 21.9283C13.9076 21.7024 14.0444 21.5238 14.2217 21.392C14.3994 21.2602 14.612 21.1807 14.8615 21.1543C15.1119 21.128 15.3896 21.1625 15.6959 21.258C16.024 21.3607 16.3212 21.5165 16.5853 21.7256C16.8502 21.9351 17.0747 22.1778 17.2588 22.4536C17.4433 22.7304 17.5846 23.028 17.6837 23.3475C17.7828 23.6675 17.8318 23.9906 17.8318 24.3164L16.8002 23.9751C16.8002 23.787 16.778 23.6061 16.733 23.4334C16.6884 23.2612 16.6198 23.1021 16.5285 22.9572C16.4367 22.8122 16.3208 22.6854 16.1813 22.5768C16.0418 22.4682 15.8777 22.3836 15.6877 22.3227C15.5096 22.2655 15.3555 22.2423 15.2256 22.2532C15.096 22.2641 14.9883 22.3027 14.9029 22.37C14.8175 22.4368 14.7543 22.5282 14.7138 22.6445C14.6734 22.7604 14.6529 22.8935 14.6529 23.0444C14.6529 23.328 14.7534 23.597 14.9547 23.8533C15.1565 24.1106 15.466 24.39 15.8841 24.6936C16.2131 24.9327 16.4998 25.1717 16.743 25.4103C16.9866 25.6502 17.1902 25.8975 17.3528 26.1506C17.5155 26.4051 17.6369 26.6705 17.7164 26.9468C17.795 27.2236 17.835 27.5176 17.835 27.8289C17.835 28.1579 17.785 28.436 17.6846 28.6624C17.5846 28.8887 17.4424 29.0596 17.2579 29.1754C17.0738 29.2913 16.8525 29.349 16.5925 29.3509C16.334 29.3522 16.0468 29.2941 15.7314 29.1768C15.4519 29.0732 15.1778 28.9205 14.9088 28.7205C14.6407 28.521 14.4016 28.2829 14.1899 28.0043C13.9794 27.7266 13.8099 27.4153 13.6822 27.0704C13.5545 26.7268 13.4905 26.3537 13.4905 25.9515L14.4757 26.3006C14.4757 26.5414 14.5075 26.7596 14.5716 26.9554C14.6357 27.1513 14.7238 27.3249 14.8352 27.4753C14.947 27.6262 15.0792 27.7548 15.2328 27.8616C15.3864 27.9684 15.5523 28.0548 15.7309 28.1193C16.0836 28.2479 16.3503 28.2502 16.5294 28.1261C16.7093 28.002 16.7993 27.783 16.7993 27.4708Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38019"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38019" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38019" result="effect2_dropShadow_3816_38019" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38019" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38019"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default ThreemfIcon;
